<template>
  <div class="dormitory-list">
    <el-table ref="multipleTable" :data="dormitoryData" tooltip-effect="dark" style="width: 100%"
      @selection-change="handleSelectionChange" class="common-edit-button">
      <el-table-column label="#" type="index"> </el-table-column>
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="blockName" label="宿舍楼名字" :show-overflow-tooltip="true" width="200px">
      </el-table-column>
      <el-table-column prop="dormName" label="宿舍编号" :show-overflow-tooltip="true" width="150px">
      </el-table-column>
      <el-table-column prop="level" label="楼层" :show-overflow-tooltip="true" width="150px">
      </el-table-column>
      <el-table-column label="宿舍规格" :show-overflow-tooltip="true" width="150px">
        <template slot-scope="scope"> {{ scope.row.dormType }}人间 </template>
      </el-table-column>
      <el-table-column prop="collect" label="入住人数" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="操作" width="400px">
        <template slot-scope="scope">
          <div class="handle-container">
            <!-- 宿舍添加学生 -->
            <el-button type="success" icon="el-icon-circle-plus-outline" size="small"
              @click="addstudent(scope.row)">添加</el-button>
            <!-- 修改 -->
            <el-button type="warning" icon="el-icon-edit" size="small" @click="editDorm(scope.row)"
              v-hasPermi="'sc:dorm:edit'">修改
            </el-button>
            <!-- 修改 -->
            <el-button type="warning" icon="el-icon-s-order" size="small" @click="changeDorm(scope.row)"
              v-hasPermi="'sc:dorm:edit'">一键换宿
            </el-button>
            <!-- 删除 -->
            <el-button type="danger" icon="el-icon-delete" size="small" @click="delDorm(scope.row)"
              v-hasPermi="'sc:dorm:delete'">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 修改宿舍信息 -->
    <editDormInfo :dialogFormVisible.sync="editShow" :dormInfo="dormInfo" v-show="editShow"
      :dictTypeList="dictTypeList" />
  </div>
</template>

<script>
import editDormInfo from "../editdorm-info/editdorm-info.vue";
export default {
  data() {
    return {
      // selectList: [],
      dormInfo: null,
      editShow: false,
    };
  },
  inject: ["refresh"],
  props: {
    dormitoryData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    dictTypeList: {
      type: Array,
    },
  },
  components: {
    editDormInfo,
  },
  created() { },
  methods: {
    // 一键更换宿舍
    changeDorm(row) {
      this.$emit("changeDorm", row);
    },
    handleSelectionChange(val) {
      // console.log(val);
      this.selectList = val;
      let list = [];
      this.selectList.forEach((item) => {
        list.push(item.id);
      });
      this.$emit("multipleDelete", list);
    },
    addstudent(item) {
      let { id, blockName, dormName, dormType } = item;
      this.$router.push({
        path: "/admin-studentDorm",
        query: {
          id,
          blockName,
          dormName,
          dormType,
        },
      });
    },
    // 修改宿舍
    editDorm(item) {
      // console.log(item);
      this.dormInfo = item;
      this.editShow = true;
    },
    // 删除宿舍
    delDorm(item) {
      this.$confirm("是否删除该宿舍?", "删除宿舍", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          // 调用删除学生信息接口
          let list = [];
          list.push(item.id);
          this.delete(this.$url.delDorm + "/" + list)
            .then((res) => {
              if (res.code == 200) {
                this.$message.success("删除成功");
                // 刷新列表
                this.refresh();
              } else {
                this.$message.error("删除失败，请稍后重试");
              }
            })
            .catch((err) => {
              console.log(err);
              // this.$message.error("删除失败，请稍后重试");
            });
        })
        .catch(() => { });
    },
  },
};
</script>

<style>
@import "./dormitoryList.scss";
</style>
